module.exports = __webpack_public_path__ + "img/11d787b.jpg";